import React from 'react';
import AcDownload from '../../components/packing_list/AcDownload';

const AcDownloadPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <AcDownload />
        </div>
    );
};

export default AcDownloadPage;
